import { deserialize, deserializeAs } from 'libs/cerialize';
import { KanbanViewModel } from 'Core/Controls/Kanban/Models/KanbanViewModel';

export class ViewListResponseModel {
    @deserializeAs(KanbanViewModel)
    KanbanViews: Array<KanbanViewModel>;

    @deserialize
    IsAddingRecordAllowed: boolean;
}